import axios from "../utils/axios";

const apiPrefix = "/api/job-search-blocker";

const resetStageNotification = async () => {
    await axios.post(`${apiPrefix}/reset-stage-notification`);
}

export {
    resetStageNotification,
};